import { useNavigate } from "react-router-dom";
import { useDrawerContext } from "../context/drawerContext";
import { useUserContext } from "../context/userContext";
import Button from "../components/Button";
import CloseIcon from "/public/images/icons/close.svg?react";

export function useLiteDrawer() {
  const { setOpen, setDrawerContent } = useDrawerContext();
  const { refreshSubscription } = useUserContext();
  const navigate = useNavigate();

  const showLiteDrawer = () => {
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            JOIN SPORTS GUARDIAN
          </h2>
          <CloseIcon className="cursor-pointer" onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-[24px] justify-stretch">
          <h3 className="text-[24px]">Join Sports Guardian</h3>
          <p className="text-sportsDarkGrey">
            Based on your lite membership, you have limited access to the
            functionality in the Sports Guardian app. To upgrade to a full
            membership and enjoy complete access to the Sports Guardian app and
            your own safety band, please tap the button below.
          </p>
          <Button
            variant="primary"
            className="w-full"
            onClick={async () => {
              const freshSubscription = await refreshSubscription();
              setOpen(false);
              if (freshSubscription?.Name === 'Lite') {
                window.open(freshSubscription?.LiteShopUrl || '/shop/my-participants', '_blank');
              }
            }}
          >
            Order Your Band
          </Button>
        </div>
      </div>
    );
    setOpen(true);
  };

  return { showLiteDrawer };
}
